import React from 'react';
import { Button, Spinner } from 'reactstrap';
import { useChatDetailsByChatId } from 'hooks/useChatDetailsByChatId';
import { ConversationCard } from 'components/Conversation/ConversationDetails/components/Card';
import UncontrolledDefaultModal from 'components/Modal/UncontrolledDefaultModal';

export const ChatDetailsModal = ({ id }) => {
  const {
    response: conversationData,
    isLoading,
    error
  } = useChatDetailsByChatId(id);

  const ModalBody = () => {
    if (isLoading) {
      return (
        <div className="text-center">
          <Spinner />
          <p>Buscando detalhes do chat...</p>
        </div>
      );
    }

    if (error) {
      return <p className="text-center text-danger">{error}</p>;
    }

    if (!conversationData) {
      return (
        <p className="text-center">Nenhum detalhe encontrado para este chat.</p>
      );
    }

    return <ConversationCard conversationData={conversationData} />;
  };

  return (
    <UncontrolledDefaultModal
      trigger={
        <Button
          color="success"
          size="sm"
          title={'Detalhes'}
          id={`${id}-chat-details`}
        >
          <i className={'fas fa-info-circle'}></i>
        </Button>
      }
      header="Detalhes do Chat"
      title={`Detalhes do Chat ID: ${id}`}
      body={<ModalBody />}
    />
  );
};
